import axios from "axios";
import { registerRootComponent } from "expo";
import { Platform, I18nManager } from "react-native";
import Orientation from "react-native-orientation";
import { storage } from "store";

import Wholesaler from "router";

I18nManager.allowRTL(false);
I18nManager.forceRTL(false);
Platform.OS !== "web" && Orientation.lockToPortrait();

// import * as serviceWorkerRegistration from "./src/serviceWorkerRegistration";

// axios.defaults.baseURL = Routes.BASE_URL;
// axios.defaults.baseURL = "https://lead-app.ir/api/wholesaler/v2/";
// axios.defaults.baseURL = 'http://bazarekashan.com/api/wholesaler/v2/';
axios.defaults.baseURL = "https://sar-nakh.ir/api/wholesaler/v2/";

axios.defaults.headers.Access = "*";
axios.defaults.headers.get["Content-Type"] = "application/json";
axios.defaults.headers.post["Content-Type"] = "application/json";

storage
  .get()
  .then((user) =>
    user?.token
      ? (axios.defaults.headers.common.Authorization = "Bearer " + user?.token)
      : null
  );

// !-------------------- should be remove in production -------------
// axios.interceptors.request.use(
//   (config) => {
//     console.log("public REQ CONFIG:::", config);
//     return config;
//   },
//   (error) => {
//     console.log("public REQ ERROR:::", error);
//     return Promise.reject(error);
//   }
// );

// axios.interceptors.response.use(
//   (res) => {
//     console.log("public RES RES:::", res);
//     return res;
//   },
//   (err) => {
//     console.log("public RES ERROR:::", err);
//     return Promise.reject(err);
//   }
// );
// !-------------------- ^^^^ should be remove in production ---------

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
registerRootComponent(Wholesaler);

// serviceWorkerRegistration.register();
